<template>
  <div class="tasks-kanban-column-indicator" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <div class="tasks-kanban-column-indicator__status" v-if="grouping.Status">
      <div
        class="tasks-kanban-column-indicator__status-bg"
        :style="{ backgroundColor: grouping.Status.Color }"
      />
      <div class="tasks-kanban-column-indicator__status-dot tasks-kanban-column-indicator__dot" />
      <span class="tasks-kanban-column-indicator__status-text">{{ grouping.Status.Name }}</span>
    </div>
    <div class="tasks-kanban-column-indicator__priority" v-else-if="grouping.Priority">
      <FlagIcon
        class="tasks-kanban-column-indicator__icon"
        :style="{ color: grouping.Priority.Color }"
      />
      <p
        class="tasks-kanban-column-indicator__priority-text"
        :style="{ color: grouping.Priority.Color }"
      >
        {{ grouping.Priority.Name }}
      </p>
    </div>
    <TirPmIconView
      v-else-if="grouping.Performer"
      :size="24"
      isRounded
      :colorCode="grouping.Performer.NoPhotoColor"
      :isBordered="false"
      :imageLoadUrl="grouping.Performer.ImageUrl"
    >
      <template #mainSlot>
        {{ grouping.Performer.FirstName[0] + grouping.Performer.LastName[0] }}
      </template>
    </TirPmIconView>
    <TirPmIconView
      v-else-if="grouping.Author"
      :size="24"
      isRounded
      :colorCode="grouping.Author.NoPhotoColor"
      :isBordered="false"
      :imageLoadUrl="grouping.Author.ImageUrl"
    >
      <template #mainSlot>
        {{ grouping.Author.FirstName[0] + grouping.Author.LastName[0] }}
      </template>
    </TirPmIconView>
    <div v-else-if="grouping.Tag">
      <div class="tasks-kanban-column-indicator__tag" :style="{ borderColor: grouping.Tag.Color }">
        <div
          class="tasks-kanban-column-indicator__tag-bg"
          :style="{ backgroundColor: grouping.Tag.Color }"
        />
        <span
          class="tasks-kanban-column-indicator__tag-text"
          :style="{ color: grouping.Tag.Color }"
          >{{ grouping.Tag.Name }}</span
        >
      </div>
    </div>
    <div v-else-if="grouping.Type" class="tasks-kanban-column-indicator__type">
      <RectangleStackIcon class="tasks-kanban-column-indicator__icon" />
      {{ grouping.Type.Name }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from "vue";
import { GroupedTaskItemModel, TasksKanbanGroupingModel } from "../models";
import { FlagIcon } from "tir-style-system/icons/solid";
import { TirPmIconView } from "tir-components";
import { RectangleStackIcon } from "tir-style-system/icons/outline";

/**Параметры */
defineProps({
  /**Группировка */
  grouping: {
    type: Object as PropType<TasksKanbanGroupingModel | GroupedTaskItemModel>,
    required: true,
  },
});
const emit = defineEmits<{
  /**Наведение курсора */
  mouseenter: [];
  /**Покидание курсора */
  mouseleave: [];
}>();

/**При наведении курсора */
const onMouseEnter = () => {
  emit("mouseenter");
};
/**При покидании курсора */
const onMouseLeave = () => {
  emit("mouseleave");
};
</script>

<style lang="scss" scoped>
.tasks-kanban-column-indicator {
  &__status {
    position: relative;
    padding: 0.125rem 0.5rem;
    border-radius: 0.375rem;
    overflow: hidden;

    display: flex;
    align-items: center;
    column-gap: 0.375rem;
  }
  &__priority {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
  &__priority-text {
    font-size: 0.688rem;
    font-weight: 400;
  }
  &__status-bg {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
  &__status-text {
    display: block;
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 1rem;
    letter-spacing: 0.063rem;
    color: var(--text-inverted-primary, #ffffff);
    z-index: 1;
  }

  &__dot {
    background-color: var(--text-inverted-primary, #ffffff);
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    z-index: 1;
  }

  &__icon {
    width: 1rem;
    height: 1rem;
  }

  &__type {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    font-weight: 400;
    color: var(--text-secondary, #686c73);
  }

  &__tag {
    position: relative;
    overflow: hidden;
    padding: 0.125rem 0.5rem;
    font-size: 0.688rem;
    border-style: solid;
    border-width: 0.063rem;
    border-radius: 0.25rem;
  }

  &__tag-bg {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    opacity: 0.1;
  }
  &__tag-text {
    position: relative;
    z-index: 1;
    line-height: 1rem;
    font-weight: 400;
  }
}
</style>
